import { Paper, Typography } from '@mui/material';

export function DetailSection({ title, children, sx }) {
  return (
    <Paper sx={{ p: { xs: 2, sm: 3 }, height: '100%', ...sx }}>
      {title && (
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {title}
        </Typography>
      )}
      {children}
    </Paper>
  );
}
